import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Analytics from "../../../../helpers/analytics";
import Chip from "@material-ui/core/Chip";
import TagsWrapper from "./styles/Tags.style";

function Tags(props) {
  const { tags, clearAllSearch } = props;

  return (
    <TagsWrapper className="video--tags">
      <div className="lp-tags">
        <ul>
          {tags.map((tag, index) => (
            <Link
              key={String(index)}
              to={`/licensing/search?q=${tag.match(/(.+ )+/) ? `%22${tag}%22` : tag}`}
              className="tag__link"
            >
              <Chip
                className="chip-tag"
                onClick={() => {
                  clearAllSearch();
                  Analytics.track("Tags", {
                    category: "LP-VideoDetail",
                    label: tag
                  });
                }}
                label={tag}
              ></Chip>
            </Link>
          ))}
        </ul>
      </div>
    </TagsWrapper>
  );
}

Tags.propTypes = {
  tags: PropTypes.array.isRequired,
  clearAllSearch: PropTypes.func.isRequired,
};

export default Tags;
